import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'

interface CitationProps {
  citation: any
  onClick: any
  elementType?: string
}

export const Citation = observer((props: CitationProps) => {
  const { elementType, citation, onClick } = props

  const onHover = (cit) => {
    document.querySelectorAll('[node_id]').forEach((node) => {
      const gqids = node.getAttribute('generated_question_ids')
      const ids = gqids?.split(',').map((id) => Number(id)) ?? []
      const content =
        node.tagName === 'TR'
          ? node
          : node.classList.contains('list-item-content')
            ? node.querySelector('.paragraph-node-content>span')
            : node.children[0]
      if (gqids && ids?.includes(cit.gqid) && !content?.classList.contains('HoveredFact')) {
        content?.classList.add('HoveredFact')
      }
    })
  }

  const onLeave = () => {
    document.querySelectorAll('.HoveredFact').forEach((e) => e.classList.remove('HoveredFact'))
  }

  const selectFact = (cit) => {
    document.querySelectorAll('.SelectedFact').forEach((e) => e.classList.remove('SelectedFact'))
    document.querySelectorAll('[node_id]').forEach((node) => {
      const gqids = node.getAttribute('generated_question_ids')
      const ids = gqids?.split(',').map((id) => Number(id)) ?? []
      const content =
        node.tagName === 'TR'
          ? node
          : node.classList.contains('list-item-content')
            ? node.querySelector('.paragraph-node-content>span')
            : node.children[0]
      if (gqids && ids?.includes(cit.gqid)) {
        content?.classList.add('SelectedFact')
      }
    })
  }

  const handleClick = () => {
    selectFact(citation)
    onClick()
  }

  const hideDuplicateCitations = () => {
    const cits = document.querySelectorAll('.cit') as any
    const citMap = {} as any

    cits.forEach((c, index) => {
      if (cits.length - 1 !== index || cits.length !== index) {
        citMap[`${c.innerText}`.trim()] = citMap[`${c.innerText}`.trim()]
          ? [...citMap[`${c.innerText}`.trim()], c]
          : [c]
      }
    })

    Object.values(citMap).map((citationArr: any) => {
      citationArr?.map((cit: HTMLElement, index) => {
        if (citationArr?.length - 1 !== index) {
          cit.setAttribute('style', 'display: none;')
        }
        if (elementType === 'li' || elementType === 'td') {
          const p2 = cit.parentElement?.parentElement?.querySelector('.node-paragraph')
          if (p2) {
            cit.parentElement?.parentElement
              ?.querySelector('.node-paragraph')
              ?.setAttribute('style', 'display: inline;')
            cit.parentElement?.parentElement?.children[0]?.children[0]?.setAttribute(
              'style',
              'display: inline;',
            )
            cit.parentElement?.parentElement
              ?.querySelector('.node-paragraph>div')
              ?.setAttribute('style', 'display: inline;')
          }
        }
      })
    })
  }

  useEffect(() => {
    hideDuplicateCitations()
  }, [])

  return (
    <sup
      className="cit"
      key={`cit-${citation.level}`}
      style={{ fontStyle: 'normal' }}
      onMouseEnter={(e) => onHover(citation)}
      onMouseLeave={(e) => onLeave()}
      onClick={handleClick}
    >{`(${citation.level}) `}</sup>
  )
})
